module.exports = __webpack_public_path__ + "static/media/opakowania_4_A.a24a1906.png";